import React from 'react';
import styled from 'styled-components';

// This component uses styled-components for styling.
// The styles are defined directly within the file.

const ServicesContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Inter', sans-serif;
  background-color: #f7fafc;
`;

const Header = styled.h1`
  text-align: center;
  font-size: 3rem;
  font-weight: 700;
  color: #2c5282;
  margin-bottom: 40px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.05);
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const ServiceCard = styled.div`
  background-color: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }
`;

const CardTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 600;
  color: #38b2ac;
  margin-bottom: 20px;
  border-bottom: 2px solid #38b2ac;
  padding-bottom: 10px;
`;

const ServiceList = styled.ul`
  list-style: none;
  padding: 0;
  flex-grow: 1;
`;

const ServiceListItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  font-size: 1rem;
  color: #4a5568;
  line-height: 1.6;
`;

const CheckIcon = styled.svg`
  margin-right: 10px;
  flex-shrink: 0;
  color: #48bb78;
`;

const SubHeader = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 15px;
`;

const realEstateServices = [
  'Property sales (land, residential and commercial buildings)',
  'Property rentals (short-term and long-term)',
  'Land surveying and Title processing',
  'Real estate marketing and advertising (photos, videos, virtual tours)',
  'Brokerage, deal negotiation, and transaction facilitation',
  'Buyer and seller representation',
  'Real estate consultancy and advisory services',
  'Real estate valuation and market analysis',
  'Investment guidance in real estate projects',
  'Relocation and housing support services',
  'Auctioning and distressed property sales',
];

const propertyManagementServices = [
  'Rent collection and financial reporting',
  'Ownership/Tenant screening and lease management',
  'Property maintenance.',
  'Vacancy marketing and advertising',
  'Asset value preservation and improvement planning',
  'Buying and selling of properties on behalf of the company and clients (both online and offline)',
  'Brokerage, deal negotiation, and transaction facilitation.',
  'Development and management of property listings and marketing materials.',
  'Client acquisition and relationship management systems.',
  'Transportation, clearing and forwarding, and Warehousing services',
];

const marketingServices = [
  'Website and landing page advertising space',
  'Business Directory Listings (Premium listings for businesses to showcase their products/services)',
  'Digital marketing campaigns (Google Ads, Facebook Ads, Instagram Ads, etc.)',
  'Sponsored Content / Native Ads (Articles, blog posts, or videos written to promote a brand while blending with your platform’s content).',
  'Social Media Promotion (Cross-promotion of client ads through your company’s social media accounts)',
  'Video Advertising (Promotional videos or commercials hosted on your platform)',
  'Influencer marketing',
  'Market trend research, data analysis, and reporting',
  'Implementation of marketing strategies including online and offline campaigns',
  'Branding and product improvement',
];

const ServicesPage = () => {
  return (
    <ServicesContainer>
      <Header>Our Services</Header>
      <ServiceGrid>
        <ServiceCard>
          <CardTitle>Real Estate  Services</CardTitle>
          <SubHeader>We provide the following real estate services.</SubHeader>
          <ServiceList>
            {realEstateServices.map((service, index) => (
              <ServiceListItem key={index}>
                <CheckIcon width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.70711 15.2929C9.31658 15.6834 8.68342 15.6834 8.29289 15.2929L5.29289 12.2929C4.90237 11.9024 4.90237 11.2692 5.29289 10.8787C5.68342 10.4881 6.31658 10.4881 6.70711 10.8787L10 14.1716L17.2929 6.87868C17.6834 6.48816 18.3166 6.48816 18.7071 6.87868C19.0976 7.26921 19.0976 7.90237 18.7071 8.29289L10.7071 16.2929C10.3166 16.6834 9.68342 16.6834 9.29289 16.2929C9.29289 16.2929 9.29289 16.2929 9.29289 16.2929L9.70711 15.2929Z" fill="currentColor" />
                </CheckIcon>
                {service}
              </ServiceListItem>
            ))}
          </ServiceList>
        </ServiceCard>

        <ServiceCard>
          <CardTitle>Property Management Services</CardTitle>
          <SubHeader>We provide the following property management services.</SubHeader>
          <ServiceList>
            {propertyManagementServices.map((service, index) => (
              <ServiceListItem key={index}>
                <CheckIcon width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.70711 15.2929C9.31658 15.6834 8.68342 15.6834 8.29289 15.2929L5.29289 12.2929C4.90237 11.9024 4.90237 11.2692 5.29289 10.8787C5.68342 10.4881 6.31658 10.4881 6.70711 10.8787L10 14.1716L17.2929 6.87868C17.6834 6.48816 18.3166 6.48816 18.7071 6.87868C19.0976 7.26921 19.0976 7.90237 18.7071 8.29289L10.7071 16.2929C10.3166 16.6834 9.68342 16.6834 9.29289 16.2929C9.29289 16.2929 9.29289 16.2929 9.29289 16.2929L9.70711 15.2929Z" fill="currentColor" />
                </CheckIcon>
                {service}
              </ServiceListItem>
            ))}
          </ServiceList>
        </ServiceCard>

        <ServiceCard>
          <CardTitle>Marketing/Advertising Services</CardTitle>
          <SubHeader>We provide the following marketing/advertising services</SubHeader>
          <ServiceList>
            {marketingServices.map((service, index) => (
              <ServiceListItem key={index}>
                <CheckIcon width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.70711 15.2929C9.31658 15.6834 8.68342 15.6834 8.29289 15.2929L5.29289 12.2929C4.90237 11.9024 4.90237 11.2692 5.29289 10.8787C5.68342 10.4881 6.31658 10.4881 6.70711 10.8787L10 14.1716L17.2929 6.87868C17.6834 6.48816 18.3166 6.48816 18.7071 6.87868C19.0976 7.26921 19.0976 7.90237 18.7071 8.29289L10.7071 16.2929C10.3166 16.6834 9.68342 16.6834 9.29289 16.2929C9.29289 16.2929 9.29289 16.2929 9.29289 16.2929L9.70711 15.2929Z" fill="currentColor" />
                </CheckIcon>
                {service}
              </ServiceListItem>
            ))}
          </ServiceList>
        </ServiceCard>
      </ServiceGrid>
    </ServicesContainer>
  );
};

export default ServicesPage;
export {};